import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

export const PROJECT_MEMBERS_CHANGED_EVENT_EMITTER_TOKEN = new InjectionToken<Subject<any>>('Project members change notification emitter');
